"use client";

import { ReactNode } from "react";
import { usePathname } from "next/navigation";
import { ThemeProvider } from "@/providers/theme-provider";
import { CursorProvider } from "@/providers/cursor-provider";
import { SmoothScroll } from "@/providers/smooth-scroll";
import { Navbar } from "@/components/layout/navbar";
import { Footer } from "@/components/layout/footer";
import { CustomCursor } from "@/components/ui/custom-cursor";
import { ScrollProgress } from "@/components/ui/scroll-progress";
import { AiAssistant } from "@/components/assistant/ai-assistant";
import { ScrollToTop } from "@/components/ui/scroll-to-top";
import { WelcomeSplash } from "@/components/ui/welcome-splash";

export function AppShell({ children }: { children: ReactNode }) {
  const pathname = usePathname();
  const isAdmin = pathname?.startsWith("/admin");

  return (
    <ThemeProvider>
      <CursorProvider>
        <SmoothScroll enabled={!isAdmin}>
          {!isAdmin ? <WelcomeSplash /> : null}
          {!isAdmin ? <ScrollProgress /> : null}
          {!isAdmin ? <CustomCursor /> : null}
          <Navbar />
          <main className="flex-1">{children}</main>
          {!isAdmin ? <Footer /> : null}
          {!isAdmin ? <ScrollToTop /> : null}
          {!isAdmin ? <AiAssistant /> : null}
        </SmoothScroll>
      </CursorProvider>
    </ThemeProvider>
  );
}
